export default {
    DEVICE_DISCONNECT: 'device-disconnect',
};
